import instObj from '@/backend/axios-instances'

const resource = "/inventories"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  getByProject(parameters) {
    return instance.get(`${resource}/projects`, { params: parameters });
  },
  adjust(data, parameters) {
    return instance.post(`${resource}/adjustments`, data, { params: parameters });
  },
  adjustProject(data, parameters) {
    return instance.post(`${resource}/projects/adjustments`, data, { params: parameters });
  },
  transfer(data, parameters) {
    return instance.post(`${resource}/transfers`, data, { params: parameters });
  },
  transform(data, parameters) {
    return instance.post(`${resource}/transformations`, data, { params: parameters });
  }
}
